// Custom modal dialogs replacing native alert/confirm/prompt

let toastContainer = null;

function ensureToastContainer() {
  if (toastContainer && document.body.contains(toastContainer)) return toastContainer;
  toastContainer = document.createElement('div');
  toastContainer.className = 'toast-container';
  document.body.appendChild(toastContainer);
  return toastContainer;
}

export function toast(message, type = 'error') {
  const container = ensureToastContainer();
  const el = document.createElement('div');
  el.className = `toast toast-${type}`;
  const icon = type === 'error' ? 'alert-circle' : type === 'success' ? 'check-circle' : 'info';
  el.innerHTML = `<i data-lucide="${icon}" style="width:16px;height:16px;flex-shrink:0"></i><span>${escDialog(message)}</span>`;
  container.appendChild(el);
  try { lucide.createIcons({ nodes: [el] }); } catch (_) {}

  requestAnimationFrame(() => el.classList.add('visible'));

  const dismiss = () => {
    el.classList.remove('visible');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
    setTimeout(() => el.remove(), 300);
  };

  el.onclick = dismiss;
  setTimeout(dismiss, 5000);
}

export function confirmDialog(message, { danger = false } = {}) {
  return new Promise(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'dialog-overlay';
    overlay.innerHTML = `
      <div class="dialog-box">
        <div class="dialog-icon ${danger ? 'danger' : ''}">
          <i data-lucide="${danger ? 'alert-triangle' : 'help-circle'}" style="width:24px;height:24px"></i>
        </div>
        <p class="dialog-message">${escDialog(message)}</p>
        <div class="dialog-actions">
          <button class="btn btn-secondary btn-sm dialog-cancel">Cancel</button>
          <button class="btn ${danger ? 'btn-danger' : 'btn-primary'} btn-sm dialog-confirm">Confirm</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    try { lucide.createIcons({ nodes: [overlay] }); } catch (_) {}

    requestAnimationFrame(() => overlay.classList.add('visible'));

    const close = (result) => {
      overlay.classList.remove('visible');
      overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      setTimeout(() => overlay.remove(), 300);
      resolve(result);
    };

    overlay.querySelector('.dialog-cancel').onclick = () => close(false);
    overlay.querySelector('.dialog-confirm').onclick = () => close(true);
    overlay.querySelector('.dialog-confirm').focus();
    overlay.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close(false);
      if (e.key === 'Enter') close(true);
    });
  });
}

export function promptDialog(message, { placeholder = '', defaultValue = '' } = {}) {
  return new Promise(resolve => {
    const overlay = document.createElement('div');
    overlay.className = 'dialog-overlay';
    overlay.innerHTML = `
      <div class="dialog-box">
        <p class="dialog-message">${escDialog(message)}</p>
        <input type="text" class="form-input dialog-input" placeholder="${escDialog(placeholder)}" value="${escDialog(defaultValue)}">
        <div class="dialog-actions">
          <button class="btn btn-secondary btn-sm dialog-cancel">Cancel</button>
          <button class="btn btn-primary btn-sm dialog-confirm">OK</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);

    requestAnimationFrame(() => overlay.classList.add('visible'));

    const input = overlay.querySelector('.dialog-input');
    input.focus();
    input.select();

    const close = (result) => {
      overlay.classList.remove('visible');
      overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      setTimeout(() => overlay.remove(), 300);
      resolve(result);
    };

    overlay.querySelector('.dialog-cancel').onclick = () => close(null);
    overlay.querySelector('.dialog-confirm').onclick = () => close(input.value);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close(null);
      if (e.key === 'Enter') close(input.value);
    });
  });
}

function escDialog(s) {
  if (s == null) return '';
  const d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}
